import React, { createContext, useContext, useEffect, useState } from 'react';
import { fetchUser } from '../services/UserService';
import {
	getAccessToken,
	getUserId,
	getUserRole,
	setUserType,
} from '../Utils/AuthUtil';
import { USER_ROLES } from '../Utils/Enums';

const MainContext = createContext();

export const MainProvider = ({ children }) => {
	const [isSidebarOpen, setIsSidebarOpen] = useState(false);
	const [initialCarePlan, setInitialCarePlan] = useState([]);
	const [initialPlanElderId, setInitialPlanElderId] = useState('');
	const [enabledUserFeatureList, setEnabledUserFeatureList] = useState([]);
	const [optimizedCarePlan, setOptimizedCarePlan] = useState({
		formattedPlan: [],
		fullPlan: [],
	});
	const [optimizedPlanData, setOptimizedPlanData] = useState({
		id: '',
		sessionId: '',
		file: [],
	});
	const [isLoading, setIsLoading] = useState(false);

	useEffect(() => {
		if (
			parseInt(getUserRole()) !== USER_ROLES.superAdmin &&
			getUserId() &&
			enabledUserFeatureList &&
			enabledUserFeatureList.length === 0
		) {
			fetchUserDetails();
		}
	}, []);

	async function fetchUserDetails() {
		setIsLoading(true);
		const id = getUserId();
		const token = getAccessToken();
		const route =
			USER_ROLES.staff === parseInt(getUserRole()) ? 'staff' : 'admin';
		const data = await fetchUser(id, token, route);
		storeEnabledUserFeatures(data.content.featuresTypes);
		setUserType(data.content.userAccountVersion);
		setIsLoading(false);
	}

	const toggleSidebar = () => setIsSidebarOpen(prev => !prev);

	const storeInitialCarePlan = carePlan => {
		setInitialCarePlan(carePlan);
	};

	const storeOptimizedCarePlan = (formattedPlan, fullPlan) => {
		setOptimizedCarePlan({ formattedPlan, fullPlan });
	};

	const storeInitialPlanElderId = id => {
		setInitialPlanElderId(id);
	};

	const storeEnabledUserFeatures = features => {
		setEnabledUserFeatureList(features);
	};

	const storeOptimizedPlanData = (id, sessionId, file) => {
		setOptimizedPlanData({ id, sessionId, file });
	};

	return (
		<MainContext.Provider
			value={{
				isSidebarOpen,
				toggleSidebar,
				optimizedCarePlan,
				initialCarePlan,
				storeInitialCarePlan,
				storeOptimizedCarePlan,
				initialPlanElderId,
				storeInitialPlanElderId,
				enabledUserFeatureList,
				storeEnabledUserFeatures,
				optimizedPlanData,
				storeOptimizedPlanData,
				isLoading,
			}}>
			{children}
		</MainContext.Provider>
	);
};

export const getSideBarStatus = () => {
	const context = useContext(MainContext);

	return {
		isSidebarOpen: context.isSidebarOpen,
		toggleSidebar: context.toggleSidebar,
	};
};

export const getInitialCarePlan = () => {
	const context = useContext(MainContext);

	return {
		initialCarePlan: context.initialCarePlan,
		storeInitialCarePlan: context.storeInitialCarePlan,
	};
};

export const getOptimizedCarePlan = () => {
	const context = useContext(MainContext);

	return {
		optimizedCarePlan: context.optimizedCarePlan,
		storeOptimizedCarePlan: context.storeOptimizedCarePlan,
	};
};

export const getInitialPlanElderId = () => {
	const context = useContext(MainContext);

	return {
		initialPlanElderId: context.initialPlanElderId,
		storeInitialPlanElderId: context.storeInitialPlanElderId,
	};
};

export const getEnabledUserFeatures = () => {
	const context = useContext(MainContext);

	return {
		enabledUserFeatureList: context.enabledUserFeatureList,
		storeEnabledUserFeatures: context.storeEnabledUserFeatures,
		isLoading: context.isLoading,
	};
};

export const getOptimizedPlanData = () => {
	const context = useContext(MainContext);

	return {
		optimizedPlanData: context.optimizedPlanData,
		storeOptimizedPlanData: context.storeOptimizedPlanData,
	};
};
